var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m256 0c-141.159 0-256 114.841-256 256s114.841 256 256 256 256-114.841 256-256-114.841-256-256-256zm0 488c-127.925 0-232-104.075-232-232s104.075-232 232-232 232 104.075 232 232-104.075 232-232 232zm120.312-337.5h-240.625c-16.094 0-29.188 13.094-29.188 29.188v152.625c0 16.094 13.093 29.188 29.188 29.188h240.625c16.094 0 29.188-13.094 29.188-29.188v-152.625c0-16.094-13.094-29.188-29.188-29.188zm-18.089 24-102.223 81.177-102.224-81.177zm18.089 163h-240.625c-2.86 0-5.188-2.327-5.188-5.188v-145.65l118.038 93.735c2.185 1.735 4.824 2.603 7.462 2.603s5.278-.867 7.462-2.603l118.039-93.735v145.65c0 2.861-2.328 5.188-5.188 5.188z"}));
}

Email.defaultProps = {"id":"Layer_1","enableBackground":"new 0 0 512 512","height":"512","viewBox":"0 0 512 512","width":"512"};

module.exports = Email;

Email.default = Email;
